module.exports = __webpack_public_path__ + "img/222A1632.593d2554.png";